import {
  Home,
  Droplets,
  Truck,
  Hammer,
  Search,
  Sparkles,
  ArrowUpRight,
} from "lucide-react";
import Reveal from "./Reveal";

const services = [
  {
    icon: Home,
    title: "Takunderhåll",
    text: "Underhåll, rengöring och förbättring av tak med skonsamma metoder som värnar om takets material och livslängd.",
    testid: "service-card-1",
  },
  {
    icon: Droplets,
    title: "Fasadtvätt",
    text: "Vid fasadtvätt använder vi soft wash — en skonsam metod där rengöringen appliceras med lågtrycksspruta istället för hårt högtryck, så fasaden kan rengöras varsamt utan onödigt slitage.",
    testid: "service-card-2",
  },
  {
    icon: Truck,
    title: "Bortforsling",
    text: "Vi tar hand om material och avfall efter avslutat arbete, så att du slipper tänka på transporten.",
    testid: "service-card-3",
  },
  {
    icon: Hammer,
    title: "Montering av nockband",
    text: "Vi monterar nockband som bidrar till att skydda nocken och förlänga takets livslängd.",
    testid: "service-card-4",
  },
  {
    icon: Search,
    title: "Besiktning före och efter",
    text: "Vi går igenom förutsättningarna före arbetet och kontrollerar resultatet efteråt, så inget förbises.",
    testid: "service-card-5",
  },
  {
    icon: Sparkles,
    title: "Övriga uppdrag inom ytservice",
    text: "Hängrännor, eftermoment och andra närliggande uppdrag — fråga gärna om du har ett specifikt behov.",
    testid: "service-card-6",
  },
];

export default function Services() {
  return (
    <section
      id="tjanster"
      data-testid="section-services"
      className="bg-[#F7F5F0] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14">
        <Reveal className="max-w-2xl mb-14 md:mb-20">
          <div className="text-[11px] tracking-[0.22em] uppercase text-[#1A362B]/70">
            Tjänster
          </div>
          <h2 className="mt-4 font-serif-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#1F2321] text-balance">
            Exempel på hur vi kan{" "}
            <span className="text-[#1A362B]">hjälpa till</span>
          </h2>
          <p className="mt-5 text-[#5C6B64] leading-relaxed max-w-xl">
            Vi anpassar arbetet efter ditt tak och din fasad. Nedan ser du
            några vanliga moment som vi ofta arbetar med — kontakta oss gärna
            om du undrar över något specifikt.
          </p>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal
                key={s.title}
                delay={i * 60}
                data-testid={s.testid}
                className="group relative bg-white border border-[#E2DCD0] rounded-2xl p-7 md:p-8 hover:shadow-[0_18px_50px_rgba(26,54,43,0.08)] hover:border-[#1A362B]/15 transition-all duration-300"
              >
                <div className="flex items-start justify-between gap-4">
                  <div className="w-12 h-12 rounded-xl bg-[#1A362B]/8 flex items-center justify-center group-hover:bg-[#1A362B] transition-colors duration-300">
                    <Icon
                      size={20}
                      className="text-[#1A362B] group-hover:text-[#F7F5F0] transition-colors duration-300"
                      strokeWidth={1.6}
                    />
                  </div>
                  <ArrowUpRight
                    size={18}
                    className="text-[#5C6B64]/50 group-hover:text-[#1A362B] group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all duration-300"
                  />
                </div>
                <h3 className="mt-7 font-serif-display text-xl md:text-2xl text-[#1F2321] leading-tight">
                  {s.title}
                </h3>
                <p className="mt-3 text-[#5C6B64] text-[15px] leading-relaxed">
                  {s.text}
                </p>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
